import { useEffect, useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { AREA_UNITS } from "../../../../utils/constants";

const InputWithUnit = ({
  type = "text",
  label,
  name,
  value,
  onChange,
  onUnitChange,
  placeholder,
  units = AREA_UNITS,
  selectedUnit: initialUnit,
  disabled = false,
}) => {
  const [selectedUnit, setSelectedUnit] = useState(initialUnit || units[0]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const wrapperRef = useRef(null);

  const handleUnitSelect = (unit) => {
    setSelectedUnit(unit);
    setDropdownOpen(false);
    onUnitChange?.(unit);
  };

  const handleInputChange = (e) => {
    if (type === "number" && e.target.value < 0) return;
    onChange(e);
  };
  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-text-secondary mb-2 ml-1">
          {label}
        </label>
      )}
      <div ref={wrapperRef} className="relative">
        <input
          type={type}
          name={name}
          value={value}
          onChange={handleInputChange}
          placeholder={placeholder}
          disabled={disabled}
          min={type === "number" ? 0 : undefined}
          className={`w-full px-4 py-3 pr-16 border border-border rounded-lg 
          focus:outline-none focus:ring-1 focus:ring-primary text-sm placeholder:text-xs
          ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"}
          ${
            type === "number"
              ? "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
              : ""
          }`}
        />

        {/* Unit dropdown */}
        <div className="absolute right-0 top-0 h-full flex items-center">
          <div
            className={`h-full border-l border-border px-1 flex items-center gap-2 bg-gray-50/50 rounded-r-lg cursor-pointer 
            hover:bg-gray-100 ${disabled ? "cursor-not-allowed" : ""}`}
            onClick={() => !disabled && setDropdownOpen(!dropdownOpen)}
          >
            <span className="text-sm text-text-secondary">{selectedUnit}</span>
            <FaChevronDown className="w-3 h-3 text-text-muted" />
          </div>

          {/* Dropdown menu */}
          {dropdownOpen && (
            <div className="absolute right-0 top-full w-full bg-gray-50 border border-border rounded shadow z-10">
              {units.map((unit) => (
                <div
                  key={unit}
                  className="px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleUnitSelect(unit)}
                >
                  {unit}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default InputWithUnit;
